/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsPreview
 */
export interface SharedserviceMelcoModelsPreview {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsPreview
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsPreview
     */
    url?: string | null;
}

export function SharedserviceMelcoModelsPreviewFromJSON(json: any): SharedserviceMelcoModelsPreview {
    return SharedserviceMelcoModelsPreviewFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function SharedserviceMelcoModelsPreviewToJSON(value?: SharedserviceMelcoModelsPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}


